<template>
  <div class="m-content" >
    <div v-if="showQuality">
      <TreasureQuality v-on:listenToChildEvent="handleBackTreasure"/>
    </div>
    <template v-else>
      <HeaderBox/>
      <div class="report-content">
        <div class="report-area">
          <p>在你看来，<span class="protrude">{{cosAbility.goal}}</span>这一职业属于<span class="protrude">{{reportText[carCategoryIndex].title}}</span>，那么这两者之间能力模型的契合度如何呢？</p>
          <img class="report-img holland-img" :src=abilityImage />
        </div>
        <div class="report-area">
          <p v-html="reportText[carCategoryIndex].text"></p>
        </div>
        <div class="report-area">
          <p>你选择的能力项和通用模型中的差异大吗？如果差异较大，请思考一下，是你的目标职位较为特殊，还是你对目标职位认识不清晰呢？如果你想测试自己在所有能力上的潜力，请移步素质库进行测评。</p>
        </div>
        <span class="protrude tag" @click="openQuality">素质库</span>
      </div>
      <FootBox :id="id"/>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import TreasureQuality from '@/page/TreasureQuality.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'DecisionReport',
  components: {
    HeaderBox,
    FootBox,
    TreasureQuality
  },
  data() {
    return {
      cosAbility:'',
      carCategoryIndex:0,
      abilityImage:'',
      reportText:[{'title':'技术/专业人员','text':'成就导向是杰出的技术人员的一项常见特质，杰出的技术人员常以杰出的标准为标杆来衡量自己的表现与成果；技术人员常常需要有根据的说服他人，并且根据他人的预期来调整自己的说法；优秀的思考能力是技术“明星”身上的常见特质；主动性体现在技术人员在困难问题解决之前所展现的耐心或耐力，以及善于把握机会提早解决未来的问题；杰出的技术人员对自己的专业能力有自信，在自己的领域中喜欢困难的挑战，在专业工作上具有责任感；技术人员需要在做报告或和他人欧通时具备一定的对他人感受的敏感度；杰出技术人员对精准度和清晰度有较高要求；专业技术人员收集信息的行为非常普遍，相互的信息网络也极为密切；许多技术性工作需要团队共同完成，所以培养合作精神非常重要；专业技术人员愿意使用专业知识来帮助他人解决问题；杰出的技术人员会专注研究方案以满足“客户”的需要。'},
        {'title':'业务人员','text':'对业务人员来说，最重要的能力是成就和行动类的能力，影响他人占据业务人员的大部分工作时间，所以影响力是杰出业务人员的重要指标；但成就导向的重要性也不亚于影响力，成就动机对于业务人员来说非常重要；人际理解是影响力发挥的基础；自信心是业务人员最重要的个人特质；关系建立一直是业务人员的重要工作；对长周期的技术性商品的销售人员来说，分析式思考也是必备的能力；销售人员需要在和他人的互动中发现固定形式或一致性；业务人员需要寻求有关产品、顾客、潜在顾客、以及竞争对手的相关信息；对长周期技术性销售工作者来说，技术性知识是一个门槛。'},
        {'title':'人类服务工作者','text':'人类服务工作者的范畴很广，杰出的人类服务工作者比较倾向有“协助他人”的动机，包括适度的成就动机、高度喜欢与人接触，以及适度的权力动机。服务工作者需要向服务对象展现出影响力（如老师对学生的影响）；教师与护士都需要完整的培养他人的能力；人际理解是人类服务的重要因素也是影响力的基础；优秀的人类服务者（如老师）给人自信的印象；自我控制力对人类服务工作者很重要，特别是他们面对危机、气愤或沮丧的对象时。'},
        {'title':'管理人员','text':'好的管理者会使用合理的影响力来改善组织的运作；对于管理者来说，成就导向包括评估绩效、设定目标，为部属或团队计算利益；团队合作精神是管理者的重要能力，通常是对团队成员使用的；对杰出的领导者来说，逻辑思考是重要特质；好的管理者需要在个人的工作职责之外，把握住好的机会为未来的问题或机会做准备；培养他人是好的管理者的必备能力；管理者需要对自己的能力和判断力有信心，勇于接受挑战性的任务；管理者要了解他人的态度、观点、情绪等，知道哪些东西可以激励他人，了解团队成员的长处和短处；在某些情况下，管理者果断下命令很重要；管理者需要收集信息以诊断和解决问题；好的管理者能够为团队向组织争取利益和资源；管理者可以找到他人看不出来的关连或形态，在复杂情况下找出关键问题。'}
      ],
      showQuality:false
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-目标职位能力大赏')
    this.getReport()
  },
  methods:{
    // 返回目标职位能力大赏
    handleBackTreasure(){
      this.showQuality = false
    },
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosAbilityReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data;
             if(Result){
               this.cosAbility=Result.cosAbility
               this.carCategoryIndex = Result.cosAbility.carCategoryIndex
               this.abilityImage = Result.cosAbility.abilityImage+ '?' + new Date().getTime()
               // 弹幕
               let num = Math.round(Math.random()),
               text = '的目标职位是'+this.cosAbility.goal
               if(num){
                 text='想从事'+this.cosAbility.goal
               }
               store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
             }
          }else{
            this.$store.commit('showMessage', {
              message: response.data.result.message,
              type: 'error'
            })
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    },
    openQuality(){
      this.showQuality = true
    }
  }
}
</script>
<style lang="stylus" scoped>
  .protrude
    color:#DC6E5A
    font-weight:bold
  .tag
    display:block
    text-align:right
    margin:auto 0.5rem
    position: fixed
    bottom: 1.3rem
    right: 0
</style>
